import { environment } from '../../environments/environment';

export class Const {
  public static connectionUrl = environment.apiUrl;
  public static socketUrl = environment.socketUrl;
  public static msGraphApi = 'https://graph.microsoft.com/v1.0';
  public static msGraphApiMe = '/me';
  public static msGraphApiMember = '/memberOf';
  public static msGraphApiGroups = '/groups';
  public static msGraphApiSites = '/sites';
  public static msGraphApiMemberLimit = '?$top=500';
  public static apiVersionsUrl = 'versions-info';
  public static apiClassification = 'classification';
  public static apiTextOcr = 'text-ocr';
  public static apiTextDetection = 'text-detection';
  public static apiUploadReport = 'upload-report';
  public static apiImageDetection = 'image-detection';
  public static apiSendEmail = 'send-email';
  public static apiStatistics = 'statistics-info';
  public static apiTrain = 'train';
  public static apiTrainPublish = 'train-publish';
  public static apiTrainDelete = 'train-delete';
  //public static msGraphApiDatasetList = `${Const.msGraphApi}${Const.msGraphApiSites}/${window.env.sharepointSiteId}/drive/items/${window.env.sharepointItemId}/children`;

  public static httpHeaderAuth = 'Authorization';
  public static httpHeaderContentType = 'Content-Type';
  public static httpHeaderContentTypeVal = 'application/json';
  public static httpHeaderAccept = 'Accept';
  public static httpHeaderAcceptVal = 'application/json';
  public static authTokenKey = 'msal.accessToken';
  public static authBearerPrefix = 'Bearer ';
  public static loginErrorKey = 'msal.login.error';
  public static unregisteredUserErrorCode = 'AADSTS90072';

  public static mlTooLongErrorCode = 504;

  public static supportedLanguages = ['en'];
  public static maxFileSize = 10485760;
  public static maxExcelRows = 50;
  public static minConfidence = 0.7;
  public static pdfFileType = 'application/pdf';
  public static docxFileType =
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  public static pptFileType =
    'application/vnd.openxmlformats-officedocument.presentationml.presentation';
  public static tiffImageType = 'image/tiff';
  public static excelFileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  public static minContentSizePx = 400;
  public static defaultRightPanelSizePx = 200;
  public static maxRightSplitAreaPercent = 0.6;
  public static regionPrecision = 0.001;
  public static minRegionSizePx = 50;
  public static base64PrefixSize = 23;
  public static base64SizeCoefficient = 0.75;
  public static refreshIntervalMs = 30 * 1000;

  public static dateFormat = 'D MMM YYYY';
  public static dateTimeFormat = 'D MMM YYYY HH:mm Z';
  public static splitSizesStorageKey = 'splitSizes';
  public static deletedReason = 'DELETED';
  public static filenameDateFormat = 'mm_dd_yyyy HH_MM_ss';
  public static reportTotalColors = [
    {
      text: '#3F4347',
      background: '#e3e3e3',
      textArgb: 'FF3F4347',
      backgroundArgb: 'FFe3e3e3',
    },
    {
      text: '#00B1A2',
      background: '#ccefec',
      textArgb: 'FF00B1A2',
      backgroundArgb: 'FFCCEFEC',
    },
    {
      text: '#FF8A00',
      background: '#ffe8cc',
      textArgb: 'FFFF8A00',
      backgroundArgb: 'ffffe8cc',
    },
    {
      text: '#FE5B56',
      background: '#ffdedd',
      textArgb: 'FFFE5B56',
      backgroundArgb: 'ffffdedd',
    },
  ];

  public static modelMetrics = {
    text_level: 'F1',
    text_risk: 'F1',
    text_reason: 'HAMMING_ACCURACY',
    text_claim: 'HAMMING_ACCURACY',
    image_claim_logo: 'F1',
    image_level_logo: 'F1',
    image_risk_logo: 'F1',
    image_reason_logo: 'F1',
    image_claim_common: 'F1',
    image_level_common: 'F1',
    image_risk_common: 'F1',
    image_reason_common: 'F1',
    image_detection: 'MAP',
  };
  public static newModelNames = {
    text_level: 'new_text_level_classification_model',
    text_risk: 'new_text_risk_classification_model',
    text_reason: 'new_text_reason_classification_model',
    text_claim: 'new_text_claim_model',
    image_claim_logo: 'new_image_claim_logo_classification_model',
    image_level_logo: 'new_image_level_logo_classification_model',
    image_risk_logo: 'new_image_risk_logo_classification_model',
    image_reason_logo: 'new_image_reason_logo_classification_model',
    image_claim_common: 'new_image_claim_common_classification_model',
    image_level_common: 'new_image_level_common_classification_model',
    image_risk_common: 'new_image_risk_common_classification_model',
    image_reason_common: 'new_image_reason_common_classification_model',
    image_detection: 'new_image_detection_model',
  };
  public static datasetNameRegex = /Dataset_v\.\d+\.\d+\.xlsm/;
}
